<section ngClass.gt-xs='section-desktop' ngClass.lt-sm='section-mobile'>
  <div fxLayout='row' fxLayout.xs='column' fxLayoutAlign='center center' style='height:100%' fxLayoutGap="20px">
    <div class='title-font'>
      LET US CONTACT YOU
    </div>
    <div class='input-style' fxLayout='row'>
      <div fxFlex fxLayout='column' fxLayoutAlign='center center'>
        <input placeholder="your&#64;email.com" [(ngModel)]='email' type='text' style='border:0px;'
          (keydown.enter)='sendEmail()' />
      </div>
      <div class='submit-email s18-primary-header-color' fxLayout='column' fxLayoutAlign='center center'
        (click)='sendEmail()'>
        <i class='fa fa-chevron-right'></i>
      </div>
    </div>
  </div>

</section>